export const getScaleFactor = (value: number, max: number) => {
  const valuePercentage = (value / max) * 100;

  if (valuePercentage <= 5) return 2;
  if (valuePercentage <= 10) return 1.8;
  if (valuePercentage <= 15) return 1.6;
  if (valuePercentage <= 20) return 1.4;
  if (valuePercentage <= 25) return 1.2;
  return 1;
};

export const getZeroValueHorizontalBarColor = (color: string) => ({
  type: 'linear' as const,
  x: 0,
  y: 0,
  x2: 1,
  y2: 0,
  colorStops: [
    { offset: 0.1, color },
    { offset: 0.11, color: 'transparent' },
  ],
});
